<template>
  <div v-if="state.visible" class="sms-challenge-overlay">
    <form class="sms-challenge" role="dialog" aria-modal="true" aria-labelledby="sms-challenge-title" @submit.prevent="confirm">
      <h2 id="sms-challenge-title">安全验证</h2>
      <p>完成图形验证后发送短信验证码</p>
      <div class="sms-challenge-row">
        <input v-model="state.answer" autofocus aria-label="图形验证码" placeholder="请输入图中字符" maxlength="4" inputmode="numeric" :disabled="state.loading || state.sending" />
        <button type="button" :disabled="state.loading || state.sending" aria-label="刷新图形验证码" @click="refresh()">
          <img v-if="state.image" :src="state.image" alt="图形验证码，点击刷新" />
          <span v-else>{{ state.loading ? '加载中…' : '点击重试' }}</span>
        </button>
      </div>
      <ErrorNotice v-if="state.error" class="sms-challenge-error" :message="state.error"></ErrorNotice>
      <div class="sms-challenge-actions">
        <button type="button" :disabled="state.sending" @click="cancel()">取消</button>
        <button type="submit" :disabled="state.loading || state.sending || !state.captchaId || !state.answer.trim()">{{ state.sending ? '发送中…' : '验证并发送' }}</button>
      </div>
    </form>
  </div>
</template>
<script setup>
import ErrorNotice from '../feedback/ErrorNotice.vue'
import { onBeforeUnmount } from 'vue'
import { webApi } from '../../services/webApi'
import { useSmsCaptcha } from '../../composables/useSmsCaptcha'
const { state, send, refresh, confirm, cancel } = useSmsCaptcha(webApi)
onBeforeUnmount(() => cancel(true))
defineExpose({ send, cancel })
</script>
<style scoped>
.sms-challenge-overlay { position: fixed; inset: 0; z-index: 12000; display: grid; place-items: center; padding: 16px; background: #15223588; }
.sms-challenge { box-sizing: border-box; width: min(100%, 420px); max-height: 85vh; overflow: auto; padding: 24px; border-radius: 16px; background: white; color: #24354b; }
.sms-challenge h2 { margin-top: 0; }
.sms-challenge-row { display: flex; gap: 10px; }
.sms-challenge-row input { min-width: 0; width: 100%; padding: 10px; border: 1px solid #dbe3ee; border-radius: 6px; }
.sms-challenge-row button { flex-shrink: 0; width: 115px; min-height: 44px; padding: 0; }
.sms-challenge-row img { display: block; width: 100%; }
.sms-challenge-actions { display: flex; justify-content: flex-end; gap: 12px; margin-top: 20px; }
.sms-challenge-actions button { padding: 10px 16px; }
.sms-challenge-error { color: #c0392b; }
</style>
